import { PlanTab } from '../../../../../components/verification/SubscriptionStep';
import { SubscriptionTerm } from '../../../../../services/exports/Constants';

export default {
  sections: {
    term: {
      description:
        'Fatturazione mensile. Il termine annuale è un impegno contrattuale, non una frequenza di fatturazione.',
      options: {
        [SubscriptionTerm.Monthly]: 'Termine mensile',
        [SubscriptionTerm.Annual]: 'Termine annuale',
      },
    },
    plans: {
      tabs: {
        [PlanTab.actual]: {
          name: 'Modello di prezzo',
          title: 'Scala di prezzi basata sul successo',
        },
        [PlanTab.legacy]: {
          name: 'Legacy',
          title: 'Piani',
        },
      },
    },
    add_ons: {
      title: 'Diventa Pro con i nostri Add-on per il Piano Essential',
      description: 'Attira nuovi ospiti e favorisci le visite ripetute con queste soluzioni software.',
    },
  },
  labels: {
    recommended: 'Consigliato',
    basket: 'Carrello: <strong>{{amount}}</strong> al mese',
  },
  buttons: {
    review_and_subscribe: 'Rivedi e abbonati',
    cancel: 'Annulla',
    basket: 'Torna al carrello',
    subscribe: 'Abbonati',
    update_subscription: 'Aggiorna abbonamento',
  },
  toasts: {
    failed_to_load_data: 'Caricamento dati non riuscito',
    failed_to_save_contract: 'Impossibile salvare il contratto di servizio',
    failed_to_create_subscription: "Impossibile creare l'abbonamento",
    subscription_created: 'Abbonamento creato con successo',
    subscription_updated: 'Abbonamento aggiornato con successo',
  },
};
